import Tumblr from "./Tumblr";

export default Tumblr;
